import VirtualPosCard from "../components/VirtualPos/VirtualPosCard";
import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getVPList } from "../../store/slices/vpListSlice";
import Loading from "../components/Loading";
import { Button, Input } from "../components/Elements";
import { turkishtoEnglish } from "../../common/helpers/globalHelpers";
import InstallmentHtmlTable, { InstallmentHtmlTableRefProps } from "../components/InstallmentHtmlTable";
import commonNetwork from "../../common/api/commonNetwork";
import { ThunkDispatch } from "redux-thunk";
import { useRecoilValue } from "recoil";
import { tenantState } from "../../store/recoil/tenant/atoms";
import PageTitle from "../components/PageTitle";
import { pageTitleTexts } from "../../constants/texts/pageTitleTexts";
import useAdminCheck from "../../hooks/useAdminCheck";

export default function PosConnectionSettings() {
  useAdminCheck();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const vpList = useSelector((state: any) => state.vpList);
  const installmentHtmlTableRef = useRef<InstallmentHtmlTableRefProps>(null);
  const [isPoses, setIsPoses] = useState(false);
  const [searchText, setSearchText] = useState("");

  const { firmInformations } = useRecoilValue(tenantState);
  const { licenseKey, taxCode } = firmInformations;

  useEffect(() => {
    posControl();
    dispatch(getVPList());
  }, []);

  const openHtmlTableModal = () => {
    installmentHtmlTableRef.current?.openModal();
  }

  const posControl = async () => {
    const data = await commonNetwork.get("/virtualpos/actives");
    if (data.isSuccess) {
      var res = data.data;
      var result = res.length > 0 ? true : false;
      setIsPoses(result);
    }
  }

  const getVpByFilter = () => {
    if (searchText.length == 0) {
      return vpList.vpList;
    }

    return vpList.vpList.filter(function (bank: any) {
      return turkishtoEnglish(bank.bankname || '')
        .toLowerCase()
        .includes(turkishtoEnglish(searchText).toLowerCase()) ||
        (bank.vpList && turkishtoEnglish(bank.vpList?.vpdisplayname || "").toLowerCase().includes(turkishtoEnglish(searchText).toLowerCase()))
    });
  }
  return (
    vpList?.vpList?.length == 0 && vpList.isFetching ? (
      <Loading desc={"Pos Bağlantıları Yükleniyor..."} />
    ) : (
      <div className="w-full">
        <PageTitle title={pageTitleTexts.posConnetcionSettings} />
        <InstallmentHtmlTable ref={installmentHtmlTableRef} licenseKey={licenseKey} taxCode={taxCode} />
        <div className="p-4 flex flex-col justify-start space-y-2 mb-5">
          <div className="flex justify-between">
            <div className="flex flex-row items-center">
              <img src={"/icons/link-dark.svg"} className="h-6 w-6 black" />
              <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
                Pos Entegrasyonları
              </span>
            </div>
            <div className="">
              <Input
                placeholder="Pos Ara..."
                type="text"
                onChange={(val) => {
                  setSearchText(val.target.value)
                }}
                value={searchText}
              />
              {isPoses ? (
                <div className="mt-4">
                  <Button size="xl" color="primary" callback={openHtmlTableModal} type="button">
                    Tüm Taksit Seçeneklerini Görüntüle
                  </Button>
                </div>
              ) : null}
            </div>
          </div>
          <div className="grid grid-cols-1  gap-4 sm:gap-3 md:grid-cols-2 xl:grid-cols-3 mt-2">
            {
              vpList.vpList.length != 0 ? (
                getVpByFilter().map((vp: any, index: number) => {
                  return (
                    <VirtualPosCard
                      key={index + "vpList.vpList"}
                      data={vp}
                    />
                  );
                })
              ) : (
                <div>Sanal Pos Yok</div>
              )
            }
          </div>
        </div>
      </div>
    )
  );
}
